import React from 'react';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/cod/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import {AutoField} from 'components/forms/fields';
import {EndSection} from 'components/forms';
import {SiteUrls} from '../../../../constants';

const NatureOfVoyage = props => {
    const {schema, initialValues} = bootstrapOldForm(
        'Nature of Voyage',
        fields
    );
    return (
        <EndSection
            {...props}
            {...{schema, initialValues}}
            redirectUrl={SiteUrls.SEA_SERVICE_DOCS}
        >
            <Typography variant='h6' align='left'>
                Nature of Voyage
            </Typography>
            <AutoField
                field={fields.nature_of_voyage}
                name='nature_of_voyage'
            />
            {props.children}
        </EndSection>
    );
};

export default NatureOfVoyage;
